import { Typography } from '@mui/material';

import { StackColumn } from 'src/components';
import Image from 'src/components/Image';

//
//

interface Props {
  title: string | JSX.Element;
  src?: string;
}

const FormHeader: React.FC<Props> = ({ title, src }) => {
  return (
    <StackColumn gap={{ xs: 4, sm: 6 }}>
      <Image
        disabledEffect
        sx={{ width: !src ? 100 : 150, height: !src ? 60 : 'auto', margin: '0 auto !important' }}
        src={
          src ||
          `https://res.cloudinary.com/carbonclick/image/upload/v1688641820/Merchant%20Portal/form-icon_wn1spw.svg`
        }
      />

      <Typography textAlign={'center'} variant="title2">
        {title}
      </Typography>
    </StackColumn>
  );
};

export default FormHeader;
